
import cssVars from "css-vars-ponyfill";
import { handleError } from "../../errorHandler";

// Support --css-vars in IE11 and other browsers.
// This scans CSS on the page, and appends new rules with the --vars replaced.
// See theme/bundle/variables.scss for --var declarations.
cssVars({
  watch: true,
  onlyLegacy: true, // Doesn't run where --vars are supported
  onlyVars: true, // Only replace var usage - !potentially breaks cascade!
  onError: (message) => handleError(message),
  onComplete: (css, node, vars) => {
    let message = "Initialised CSS vars for legacy browser:\n";
    for (const key of Object.keys(vars)) {
      message += `  ${key}: ${vars[key]}\n`;
    }
    console.debug(message);
  },
});
